module.exports = __webpack_public_path__ + "img/jppdimg_mo2.ab1cae59.png";